import React from "react";

const Flash = () => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.24028 12.2645H8.96596V18.6156C8.96596 20.0975 9.76866 20.3974 10.7478 19.286L17.4253 11.7C18.2456 10.7738 17.9016 10.0064 16.6578 10.0064H13.9322V3.65528C13.9322 2.17336 13.1294 1.87344 12.1503 2.98488L5.47286 10.5709C4.66133 11.5059 5.00535 12.2645 6.24028 12.2645Z"
      stroke="#585E66"
      strokeWidth="1.69362"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Flash;
